import * as React from "react";

import { renderToggleButton_unstable } from "@fluentui/react-components";

import { useRibbonSplitButtonPrimaryToggleButton } from "./useRibbonSplitButtonPrimaryToggleButton";
import { useRibbonSplitButtonPrimaryToggleButtonStyles } from "./useRibbonSplitButtonPrimaryToggleButtonStyles.styles";
import type { RibbonToggleButtonProps } from "../../RibbonToggleButton/next";

export const RibbonSplitButtonPrimaryToggleButton = React.memo(
  React.forwardRef<HTMLButtonElement, RibbonToggleButtonProps>((props, ref) => {
    "use forget";

    const state = useRibbonSplitButtonPrimaryToggleButton(props, ref);

    useRibbonSplitButtonPrimaryToggleButtonStyles(state);

    return renderToggleButton_unstable(state);
  })
);

RibbonSplitButtonPrimaryToggleButton.displayName =
  "next/RibbonSplitButtonPrimaryToggleButton";
